<template>
    <div class="mt-4 pr-2 pl-2 pt-2 border_all" style="border: thin solid rgba(0,0,0,.12)" elevation="0">
        <v-toolbar elevation="0">
            <v-spacer></v-spacer>

            <v-btn class="ml-2" color="primary" @click.native="getRekenings(opsitable)">
                <v-icon dark>refresh</v-icon>Refresh
            </v-btn>

            <v-btn class="ml-2" color="primary" @click.native="toggleModalAddRekening()">
              <v-icon dark>add</v-icon>Tambah
            </v-btn>

        </v-toolbar>
        <v-divider></v-divider>
        <v-data-table
                :headers="headers"
                :items="rekenings"
                class="elevation-0"
                item-key="id"
                :options.sync="opsitable"
                :loading="loading"
                :disable-pagination=true
                @update:options="getRekenings(opsitable)"
        >

          <template v-slot:item.cashFlowStatus="{ item }">
            <v-chip color="red" v-if="statusPembayaran(item) == 'JATUH_TEMPO'"> Jatuh Tempo </v-chip>
            <v-chip color="orange" v-if="statusPembayaran(item) == 'BELUM_BAYAR'" > Belum Bayar </v-chip>
            <v-chip color="purple" v-if="statusPembayaran(item) == 'ON_CONFIRMATION'"> Sedang Konfirmasi </v-chip>
            <v-chip color="green" v-if="statusPembayaran(item) == 'SUCCESS'"> Berhasil </v-chip>
          </template>
        </v-data-table>
    </div>
</template>

<script>
    import moment from "moment";
    import {mapActions, mapState} from "vuex";
    import Utils from "@/plugins/utils";
    export default {
        name: "Rekening",
        data: ()=>({
            search: '',
            menu1: false,
            menu2: false,
            dateawal: moment().add(7,'hours').toISOString().substr(0, 10),
            dateakhir: moment().add(7,'hours').toISOString().substr(0, 10),
            opsitable: {
                search:'',
                itemsPerPage: 10,
                page:1,
                sortBy: ["id"],
                awal: moment().add(7,'hours').toISOString().substr(0, 10),
                akhir: moment().add(7,'hours').toISOString().substr(0, 10),
            },
            headers: [
              {
                  text: 'id',
                  value: 'id'
              },
              {
                text: 'Nama',
                value: 'name'
              },
              {
                text: 'No Rek',
                value: 'bankNo'
              },
              {
                text: 'Remark',
                value: 'remark'
              },
              {
                  text: 'Status',
                  value: 'status'
              }
            ],
        }),
        computed: {
            ...mapState('Bayartempo',['loading','rekenings'])
        },
        methods: {

            ...mapActions('Bayartempo',['getRekenings','toggleModalAddRekening']),
            formatAngka(val){
                return Utils.formatAngka(val)
            },
            statusPembayaran(item){

              if(item.status == "NOTPAID" && item.cashFlowStatus != "ALREADY_REPAYMENT" && moment(item.expiredAt).diff(new Date(), "day") < 0){
                return "JATUH_TEMPO";
              }else if (item.status == "NOTPAID" && item.cashFlowStatus == "PASS_ON_DISBURSEMENT"){
                return "BELUM_BAYAR"
              }else if(item.cashFlowStatus == "ALREADY_REPAYMENT"){
                return "ON_CONFIRMATION"
              }else if(item.cashFlowStatus == "SUCCESS"){
                return "SUCCESS"
              }

            },
            formatDate (value) {
                return moment(value).add(7,'hours').format("YYYY/MM/DD HH:mm:ss")
            },
            statusformat (value) {
                let a = 'Proses'
                if (value === 1) {
                    a = 'Sukses'
                }
                return a
            },
        }
    }
</script>

<style scoped>

</style>
